<template>
  <div class="hello">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
    >
      <div v-html="msg"></div>
    </modal>
    <header class="navbar">
      <img class="logo" src="../assets/logo1.png" alt="" />

      <span class="lang-switch">
        <a
          v-if="this.$i18n.locale === 'zh'"
          @click="changeLang('en')"
          href="javascript:;"
          >EN</a
        >
        <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
      </span>
    </header>
    <div class="cover-container form-insc text-center w-100 m-auto align-left">
      <h1>{{ $t("easyInsc") }}</h1>

      <p class="no-wrap" v-if="currentAddress">
        {{ $t("currentAddress") }}: {{ currentAddress }}
      </p>
      <p v-if="chainId">
        {{ $t("currentChain") }}:
        {{
          chainIdMap[Number(chainId)]
            ? chainIdMap[Number(chainId)].CHAIN_PARAMS[0].chainName
            : chainId
        }}
      </p>

      <p class="mb-1 mt-3">{{ $t("network") }}:</p>
      <select class="form-control" v-model="selectedChainId">
        <option
          v-for="chain in chains"
          v-bind:key="chain.value"
          v-bind:value="chain.value"
        >
          {{ chain.text }}
        </option>
      </select>

      <p class="mb-1 mt-3">{{ $t("inscribeContent") }}:</p>

      <p class="mb-1">
        <label class="radio-label" for="one">
          <input
            type="radio"
            id="one"
            value="textString"
            v-model="textType"
          />{{ $t("textString") }}
        </label>

        <label class="radio-label" for="two">
          <input type="radio" id="two" value="hexString" v-model="textType" />
          {{ $t("hexString") }}</label
        >
      </p>
      <p>
        <input
          type="text"
          class="form-control"
          v-model="inputText"
          :placeholder="textPlaceholder"
        />
      </p>

      <p>
        <input
          type="text"
          class="form-control"
          v-model="showText"
          readonly
          disabled
          :placeholder="showTextPlaceholder"
        />
      </p>

      <p class="mb-1 mt-3">{{ $t("repeatTime") }}:</p>
      <input type="number" class="form-control" v-model="times" />
      <p class="tips">{{ $t("repeatTips") }}</p>

      <p class="mb-1 mt-3 confirm-btn-wrap" style="text-align: center">
        <button class="btn btn-primary" disabled v-if="minting">
          {{ $t("minting") }}
        </button>
        <button
          v-else-if="currentAddress && networkMatched"
          class="btn btn-primary"
          @click="mint()"
        >
          {{ $t("mint") }}
        </button>
        <button
          class="btn btn-primary"
          v-else-if="currentAddress && !networkMatched"
          @click="switchNetwork()"
        >
          {{ $t("switchNetwork") }}
        </button>
        <button v-else class="btn btn-primary" @click="connectWallet()">
          {{ $t("connect") }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

function hex2a(hexString) {
  var hex = hexString.toString();
  var str = "";
  for (var i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return str;
}

function ascii2hex(str) {
  var u = unescape(encodeURIComponent(str));
  return u
    .split("")
    .map(function (c) {
      return c.charCodeAt(0).toString(16);
    })
    .join("");
}

const NETWORK_INFO = {
  ETH: {
    CHAIN_PARAMS: [
      {
        chainId: "0x1",
        chainName: "Ethereum Mainnet",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: [
          "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        ],
        blockExplorerUrls: ["https://cn.etherscan.com/"],
      },
    ],
    blockchain_id: "1",
    explorer: "http://etherscan.io/tx/",
    addressExplorer: "https://etherscan.com/address/{account}",
  },
  BSC: {
    CHAIN_PARAMS: [
      {
        chainId: "0x38",
        chainName: "BNB Chain",
        nativeCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        rpcUrls: ["https://bsc-dataseed3.defibit.io"],
        blockExplorerUrls: ["https://bscscan.com/"],
      },
    ],
    blockchain_id: "12",
    explorer: "https://bscscan.com/tx/",
    addressExplorer: "https://bscscan.com/address/{account}",
  },
  HECO: {
    CHAIN_PARAMS: [
      {
        chainId: "0x80",
        chainName: "HECO Chain",
        nativeCurrency: {
          name: "HT",
          symbol: "HT",
          decimals: 18,
        },
        rpcUrls: ["https://http-mainnet-node.huobichain.com"],
        blockExplorerUrls: ["https://hecoinfo.com/"],
      },
    ],
    blockchain_id: "15",
    explorer: "https://hecoinfo.com/tx/",
    addressExplorer: "https://hecoinfo.com/address/{account}",
  },
  MATIC: {
    CHAIN_PARAMS: [
      {
        chainId: "0x89",
        chainName: "Polygon",
        nativeCurrency: {
          name: "MATIC",
          symbol: "MATIC",
          decimals: 18,
        },
        rpcUrls: ["https://polygon-rpc.com"],
        blockExplorerUrls: ["https://polygonscan.com/"],
      },
    ],
    blockchain_id: "18",
    explorer: "https://polygonscan.com/tx/",
    addressExplorer: "https://polygonscan.com/address/{account}",
  },

  FTM: {
    CHAIN_PARAMS: [
      {
        chainId: "0xfa",
        chainName: "Fantom",
        nativeCurrency: {
          name: "FTM",
          symbol: "FTM",
          decimals: 18,
        },
        rpcUrls: ["https://rpcapi.fantom.network"],
        blockExplorerUrls: ["https://ftmscan.com/"],
      },
    ],
    blockchain_id: "25",
    explorer: "https://ftmscan.com/tx/",
    addressExplorer: "https://ftmscan.com/address/{account}",
  },
  OKTC: {
    CHAIN_PARAMS: [
      {
        chainId: "0x42",
        chainName: "OKChain",
        nativeCurrency: {
          name: "OKT",
          symbol: "OKT",
          decimals: 18,
        },
        rpcUrls: ["https://exchainrpc.okex.org"],
        blockExplorerUrls: ["https://www.oklink.com/okexchain/"],
      },
    ],
    blockchain_id: "20",
    explorer: "https://www.oklink.com/okc/tx/",
    addressExplorer: "https://www.oklink.com/okexchain/address/{account}",
  },
  ARB: {
    CHAIN_PARAMS: [
      {
        chainId: "0xa4b1",
        chainName: "Arbitrum",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://arb1.arbitrum.io/rpc"],
        blockExplorerUrls: ["https://arbiscan.io/"],
      },
    ],
    blockchain_id: "24",
    explorer: "https://arbiscan.io/tx/",
    addressExplorer: "https://arbiscan.io/address/{account}",
  },
  AVAX: {
    CHAIN_PARAMS: [
      {
        chainId: "0xa86a",
        chainName: "Avalanche",
        nativeCurrency: {
          name: "AVAX",
          symbol: "AVAX",
          decimals: 18,
        },
        rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
        blockExplorerUrls: ["https://cchain.explorer.avax.network/"],
      },
    ],
    blockchain_id: "23",
    explorer: "https://snowtrace.io/tx/",
    addressExplorer: "https://cchain.explorer.avax.network/address/{account}",
  },
  KCC: {
    CHAIN_PARAMS: [
      {
        chainId: "0x141",
        chainName: "KCC Mainnet",
        nativeCurrency: {
          name: "KCS",
          symbol: "KCS",
          decimals: 18,
        },
        rpcUrls: ["https://rpc-mainnet.kcc.network"],
        blockExplorerUrls: ["https://explorer.kcc.io/"],
      },
    ],
    blockchain_id: "35",
    explorer: "https://explorer.kcc.io/en/tx/",
    addressExplorer: "https://explorer.kcc.io/en/address/{account}",
  },
  CFX: {
    CHAIN_PARAMS: [
      {
        chainId: "0x406",
        chainName: "Conflux eSpace",
        nativeCurrency: {
          name: "CFX",
          symbol: "CFX",
          decimals: 18,
        },
        rpcUrls: ["https://evm.confluxrpc.com"],
        blockExplorerUrls: ["https://evm.confluxscan.net/"],
      },
    ],
    blockchain_id: "36",
    explorer: "https://evm.confluxscan.net/tx/",
    addressExplorer: "https://evm.confluxscan.net/address/{account}",
  },
  GLMR: {
    CHAIN_PARAMS: [
      {
        chainId: "0x504",
        chainName: "Moonbeam",
        nativeCurrency: {
          name: "GLMR",
          symbol: "GLMR",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.api.moonbeam.network"],
        blockExplorerUrls: ["https://moonscan.io/"],
      },
    ],
    blockchain_id: "31",
    explorer: "https://moonscan.io/tx/",
    addressExplorer: "https://moonscan.io/address/{account}",
  },
  KLAY: {
    CHAIN_PARAMS: [
      {
        chainId: "0x2019",
        chainName: "Klaytn",
        nativeCurrency: {
          name: "KLAY",
          symbol: "KLAY",
          decimals: 18,
        },
        rpcUrls: ["https://klaytno.mytokenpocket.vip"],
        blockExplorerUrls: ["https://scope.klaytn.com/"],
      },
    ],
    blockchain_id: "22",
    explorer: "https://scope.klaytn.com/tx/",
    addressExplorer: "https://scope.klaytn.com/account/{account}",
  },
  OP: {
    CHAIN_PARAMS: [
      {
        chainId: "0xa",
        chainName: "Optimism",
        nativeCurrency: {
          name: "OETH",
          symbol: "OETH",
          decimals: 18,
        },
        rpcUrls: ["https://mainnet.optimism.io/"],
        blockExplorerUrls: ["https://optimistic.etherscan.io/"],
      },
    ],
    blockchain_id: "26",
    explorer: "https://optimistic.etherscan.io/tx/",
    addressExplorer: "https://optimistic.etherscan.io/address/{account}",
  },
  ETC: {
    CHAIN_PARAMS: [
      {
        chainId: "0x3d",
        chainName: "Ethereum Classic",
        nativeCurrency: {
          name: "ETC",
          symbol: "ETC",
          decimals: 18,
        },
        rpcUrls: ["https://www.ethercluster.com/etc"],
        blockExplorerUrls: ["https://blockscout.com/etc/mainnet/"],
      },
    ],
    blockchain_id: "41",
    explorer: "https://blockscout.com/etc/mainnet/tx/",
    addressExplorer: "https://blockscout.com/etc/mainnet/address/{account}",
  },
  ETHW: {
    CHAIN_PARAMS: [
      {
        chainId: "0x2711",
        chainName: "ETHPoW",
        nativeCurrency: {
          name: "ETHW",
          symbol: "ETHW",
          decimals: 18,
        },
        rpcUrls: ["https://mainnet.ethereumpow.org"],
        blockExplorerUrls: ["https://www.oklink.com/en/ethw/"],
      },
    ],
    blockchain_id: null,
    explorer: "https://www.oklink.com/en/ethw/tx/",
    addressExplorer: "https://www.oklink.com/cn/ethw/address/{account}",
  },
  ETHF: {
    CHAIN_PARAMS: [
      {
        chainId: "0x7d44c",
        chainName: "EthereumFair",
        nativeCurrency: {
          name: "ETHF",
          symbol: "ETHF",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.etherfair.org"],
        blockExplorerUrls: ["https://explorer.etherfair.org"],
      },
    ],
    blockchain_id: null,
    explorer: "https://explorer.etherfair.org/tx/",
    addressExplorer: "https://www.oklink.com/cn/ethf/address/{account}",
  },
  "zkSync Era": {
    CHAIN_PARAMS: [
      {
        chainId: "0x144",
        chainName: "zkSync Era",
        nativeCurrency: {
          name: "Ether",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://zksync2-mainnet.zksync.io"],
        blockExplorerUrls: ["https://explorer.zksync.io/"],
      },
    ],
    blockchain_id: "46",
    explorer: "https://explorer.zksync.io/tx/",
    addressExplorer: "https://explorer.zksync.io/address/{account}",
  },
  "EOS EVM": {
    CHAIN_PARAMS: [
      {
        chainId: "0x4571",
        chainName: "EOS EVM",
        nativeCurrency: {
          name: "EOS",
          symbol: "EOS",
          decimals: 18,
        },
        rpcUrls: ["https://api.evm.eosnetwork.com"],
        blockExplorerUrls: ["https://explorer.evm.eosnetwork.com/"],
      },
    ],
    blockchain_id: "47",
    explorer: "https://explorer.evm.eosnetwork.com/tx/",
    addressExplorer: "https://explorer.evm.eosnetwork.com/address/{account}",
  },
  Base: {
    CHAIN_PARAMS: [
      {
        chainId: "0x2105",
        chainName: "Base",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://developer-access-mainnet.base.org"],
        blockExplorerUrls: ["https://basescan.org/"],
      },
    ],
    explorer: "https://basescan.org/tx/",
    addressExplorer: "https://basescan.org/address/{account}",
  },
  LINEA: {
    CHAIN_PARAMS: [
      {
        chainId: "0xe708",
        chainName: "Linea",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: [
          "https://linea-mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
        ],
        blockExplorerUrls: ["https://lineascan.build/"],
      },
    ],
    blockchain_id: "50",
    explorer: "https://lineascan.build/tx/",
    addressExplorer: "https://lineascan.build/address/{account}",
  },
  OPBNB: {
    CHAIN_PARAMS: [
      {
        chainId: "0xcc",
        chainName: "opBNB",
        nativeCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        rpcUrls: ["https://opbnb-mainnet-rpc.bnbchain.org"],
        blockExplorerUrls: ["https://mainnet.opbnbscan.com/"],
      },
    ],
    blockchain_id: "52",
    explorer: "https://mainnet.opbnbscan.com/tx/",
    addressExplorer: "https://mainnet.opbnbscan.com/address/{account}",
  },
  Mantle: {
    CHAIN_PARAMS: [
      {
        chainId: "0x1388",
        chainName: "Mantle",
        nativeCurrency: {
          name: "MNT",
          symbol: "MNT",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.mantle.xyz"],
        blockExplorerUrls: ["https://explorer.mantle.xyz/"],
      },
    ],
    blockchain_id: "49",
    explorer: "https://explorer.mantle.xyz/tx/",
    addressExplorer: "https://explorer.mantle.xyz/address/{account}",
  },
  SCROLL: {
    CHAIN_PARAMS: [
      {
        chainId: "0x82750",
        chainName: "Scroll",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.scroll.io"],
        blockExplorerUrls: ["https://blockscout.scroll.io/"],
      },
    ],
    blockchain_id: "56",
    explorer: "https://blockscout.scroll.io/tx/",
    addressExplorer: "https://blockscout.scroll.io/address/{account}",
  },
  CORE: {
    CHAIN_PARAMS: [
      {
        chainId: "0x45c",
        chainName: "Core",
        nativeCurrency: {
          name: "CORE",
          symbol: "CORE",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.coredao.org/"],
        blockExplorerUrls: ["https://scan.coredao.org/"],
      },
    ],
    blockchain_id: "54",
    explorer: "https://scan.coredao.org/tx/",
  },
};

const CHAIN_SELECT = (function () {
  return Object.keys(NETWORK_INFO).map((item) => {
    return {
      text: NETWORK_INFO[item].CHAIN_PARAMS[0].chainName,
      value: Number(NETWORK_INFO[item].CHAIN_PARAMS[0].chainId),
    };
  });
})();

const CHAINID_TO_CHAIN = (function () {
  var obj = {};
  Object.keys(NETWORK_INFO).forEach((item) => {
    obj[Number(NETWORK_INFO[item].CHAIN_PARAMS[0].chainId)] =
      NETWORK_INFO[item];
  });

  return obj;
})();

export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
      currentAddress: "",
      minting: false,
      chainId: "",
      inputText: "",
      times: 1,
      selectedChainId: 1,
      textType: "textString",
      chains: CHAIN_SELECT,
      chainIdMap: CHAINID_TO_CHAIN,
    };
  },
  created() {},

  mounted() {
    // try to get accounts
    if (window.ethereum) {
      window.ethereum
        .request({
          method: "eth_accounts",
          params: [],
        })
        .then(async (res) => {
          this.currentAddress = res[0];

          if (this.currentAddress) {
            this.chainId = await ethereum.request({
              method: "eth_chainId",
              params: [],
            });
            this.selectedChainId = Number(this.chainId);
          }
        });
    }

    ethereum.on("accountsChanged", (accounts) => {
      this.currentAddress = accounts[0];
    });
    ethereum.on("chainChanged", (chain) => {
      this.chainId = chain;
    });
  },
  computed: {
    networkMatched: function () {
      return (
        this.chainId && Number(this.chainId) === Number(this.selectedChainId)
      );
    },
    showTextPlaceholder: function () {
      if (this.textType === "textString") {
        return "646174613a2c7b2270223a226572632d";
      } else {
        return 'data:,{"p":"erc-20","op":"mint"...';
      }
    },
    textPlaceholder: function () {
      if (this.textType === "textString") {
        return 'data:,{"p":"erc-20","op":"mint"...';
      } else {
        return "646174613a2c7b2270223a226572632d";
      }
    },
    showText: function () {
      if (this.textType === "textString") {
        return ascii2hex(this.inputText);
      } else {
        return hex2a(this.inputText);
      }
    },
  },
  methods: {
    connectWallet() {
      if (window.ethereum) {
        window.ethereum
          .request({
            method: "eth_requestAccounts",
            params: [],
          })
          .then(async (res) => {
            this.currentAddress = res[0];

            this.chainId = await ethereum.request({
              method: "eth_chainId",
              params: [],
            });
          });
      } else {
        this.showMsg(this.$t("downloadTP"));
      }
    },
    showMsg(msg) {
      this.msg = msg;
      this.$modal.show("message");
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
    switchNetwork: function () {
      if (window.ethereum) {
        window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [
              {
                chainId: "0x" + Number(this.selectedChainId).toString(16),
              },
            ],
          })
          .catch((err) => {
            window.ethereum.request({
              method: "wallet_addEthereumChain",
              params:
                this.chainIdMap[Number(this.selectedChainId)].CHAIN_PARAMS,
            });
          });
      }
    },
    async mint() {
      if (window.ethereum && this.times > 0 && this.inputText) {
        let hexStr = _.trim(
          this.textType === "hexString"
            ? this.inputText
            : ascii2hex(this.inputText)
        );

        hexStr = hexStr.indexOf("0x") !== 0 ? "0x" + hexStr : hexStr;

        if (!/^[0-9A-F]+$/i.test(hexStr.substr(2))) {
          return;
        }

        this.minting = true;

        try {
          for (var i = 0; i < this.times; i++) {
            await ethereum
              .request({
                method: "eth_sendTransaction",
                params: [
                  {
                    from: this.currentAddress,
                    to: this.currentAddress,
                    value: 0,
                    data: hexStr,
                  },
                ],
              })
              .then(() => {
                this.minting = false;
              });
          }
        } catch {
          this.minting = false;
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
h1 {
  margin-top: 24px;
  text-align: center;
  font-size: 26px !important;
}
.form-insc {
  max-width: 680px;
  width: 90% !important;
  font-size: 15px;
}
.align-left {
  text-align: left !important;
}

.radio-label {
  margin-right: 12px;
  input {
    margin-right: 4px;
  }
}

.logo {
  width: 60%;
  max-width: 240px;
}

.no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::placeholder {
  color: #ccc;
  opacity: 1; /* Firefox */
}

.tips {
  color: #666;
  font-size: 13px;
}

.lang-switch {
  float: right;
}

.msg-modal {
  padding: 24px 18px;
  border-radius: 8px;
  background: #eee;
}

.confirm-btn-wrap {
  .btn {
    padding-left: 64px;
    padding-right: 64px;
  }
}

.navbar {
  padding: 20px;
}
</style>
